// extracted by mini-css-extract-plugin
module.exports = {"redeemedSuccessful":"RedeemedSuccessful_redeemedSuccessful__1Kp6o","text":"RedeemedSuccessful_text__5sNgH"};